import { createElement, ReactNode, MouseEvent } from 'react';
import classNames from 'classnames';

export interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement | HTMLAnchorElement> {
  text: string;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  href?: string;
  size?: 'xs' | 'small' | 'medium' | 'large';
  disabled?: boolean;
  color?: 'grey' | 'default' | 'primary' | 'cta';
  border?: boolean;
  children?: ReactNode;
}

export const Button = ({
  text,
  className = '',
  onClick = () => {},
  href,
  size = 'medium',
  disabled = false,
  color = 'default',
  border = false,
  children,
  type,
  ...props
}: ButtonProps) => {
  const tag = href ? 'a' : 'button';

  return createElement(
    tag,
    {
      onClick,
      className:
        classNames('c-button', {
          'is-xs': size === 'xs',
          'is-small': size === 'small',
          'is-medium': size === 'medium',
          'is-large': size === 'large',
          'is-disabled': !!disabled,
          'is-grey': color === 'grey',
          'is-default': color === 'default',
          'is-primary': color === 'primary',
          'is-cta': color === 'cta',
          'is-border': !!border,
        }) +
        ' ' +
        className,
      href,
      ...(tag === 'a' && { target: '_blank' }),
      type,
      ...props,
    },
    [text, children]
  );
};
